import {FontProperty} from '../FontProperty';
import {ImageProperty} from '../ImageProperty';
import {Row} from './Row';
import {Column} from './Column';

export class Element {
  type: number;
  text: string | HTMLElement | any;
  rows: Array<Row> | [];
  columns: Array<Column> | [];
  fontProperty: FontProperty;
  imageProperty: ImageProperty;
  style: string;
  parameters: any | Array<any>;
}
